export default {
    path: 'invoice',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/invoice/InvoiceList'),
    meta: { title: '在线开票',cate:'开票中心' },
    children: [
        {
            path: 'apply',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/invoice/ApplyInvoice'),
            meta: { title: '申请开票' },
        },
        {
            path: 'recharge',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/invoice/batchSelect'),
            meta: { title: '批量开票' },
        },
        {
            path: 'detail',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/common/invoiceDetails'),
            meta: { title: '申请详情' },
        },
    ]
}